import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import { components } from "react-select";
import { apiRemoteSuggest } from "../../services/apis/office/apiRemoteSuggest";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { connect } from "react-redux";

function arrayMove(array, from, to) {
  array = array.slice();
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
  return array;
}

const SortableMultiValue = SortableElement((props) => {
  const onMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const innerProps = { onMouseDown };
  return <components.MultiValue {...props} innerProps={innerProps} />;
});

const SortableAsyncSelect = SortableContainer(AsyncSelect);

function RemoteAutoSuggest(props) {
  const [selectedValue, setSelectedValue] = useState(null);
  const [defaultOptions, setDefaultOptions] = useState(null);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newValue = arrayMove(selectedValue, oldIndex, newIndex);
    setSelectedValue(newValue);
    props.dispatch({
      type: "ADD_TO_FILTER",
      payload: { key: props.filter_name, value: newValue },
    });
    props.onChange(props.component_name, newValue);
  };

  useEffect(() => {
    setSelectedValue(props.defaultVal);
    props.dispatch({
      type: "ADD_TO_FILTER",
      payload: { key: props.filter_name, value: props.defaultVal },
    });
  }, [props.defaultVal]);

  // handle selection
  const handleChange = (value) => {
    if (value.length > selectedValue.length) {
      props.dispatch({
        type: "ADD_TO_FILTER",
        payload: { key: props.filter_name, value: value },
      });
    } else {
      props.dispatch({
        type: "REMOVE_FROM_FILTER",
        payload: { key: props.filter_name, value: value },
      });
    }
    setSelectedValue(value);
    props.onChange(props.component_name, value);
  };

  // load options using API call
  const loadOptions = (inputValue) => {
    var query = "";
    Object.keys(props.filter).map((filter_name, i) => {
      Object.values(props.filter)[i].map((filters) => {
        query += "&" + filter_name + "[]=" + encodeURIComponent(filters.value);
      });
    });

    // if (inputValue.length > 1) {
    return apiRemoteSuggest
      .get(
        `?q=${props.component_name}${query}&screener=edge_office&search_term=${inputValue}`
      )
      .then((res) => res.data.suggestions);
    // }
  };

  const onFocus = (inputValue) => {
    var query = "";
    Object.keys(props.filter).map((filter_name, i) => {
      Object.values(props.filter)[i].map((filters) => {
        query += "&" + filter_name + "[]=" + encodeURIComponent(filters.value);
      });
    });

    apiRemoteSuggest
      .get(`?q=${props.component_name}${query}&screener=edge_office`)
      .then((res) => {
        setDefaultOptions(res.data.suggestions);
      });
  };

  const colourStyles = {
    container: (provided) => ({
      ...provided,
      width: "60%",
    }),
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        fontSize: "11px",
      };
    },
  };

  return (
    <SortableAsyncSelect
      // name="text4"
      // cacheOptions
      axis="xy"
      distance={4}
      getHelperDimensions={({ node }) => node.getBoundingClientRect()}
      onSortEnd={onSortEnd}
      defaultOptions={defaultOptions}
      value={selectedValue}
      defaultValue={selectedValue}
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
      loadOptions={loadOptions}
      onFocus={onFocus}
      onChange={handleChange}
      isMulti
      styles={colourStyles}
      maxMenuHeight={200}
      components={{
        MultiValue: SortableMultiValue,
      }}
      backspaceRemovesValue={true}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    filter: state.filter,
  };
};

export default connect(mapStateToProps, null)(RemoteAutoSuggest);
// export default RemoteAutoSuggest;
